import { Stack } from "capitalrx-components-2.0/lib/layout";
import { PharmacyJourneyLayout } from "@/basic/layouts/PharmacyJourneyLayout";
import { JourneySteps, FormularyButtonContainer, PharmacyJourneyZipContainer } from "@/basic/components";

export const PharmacyJourney = () => {
  return (
    <PharmacyJourneyLayout>
      <div>
        <Stack spacing="large">
          <JourneySteps />
          <PharmacyJourneyZipContainer />
          <FormularyButtonContainer />
        </Stack>
      </div>
    </PharmacyJourneyLayout>
  );
};
